export class FilterSearch {
  constructor(
    public key?: string,
    public value?: any,
  ) {}
}
